import { DateTime } from 'luxon';

export const isPast = (date: Date) => {
  const today = DateTime.local();
  const dateToCheck = DateTime.fromJSDate(date);

  return today > dateToCheck;
};
